import dynamic from 'next/dynamic';

import { StoryblokRichTextData } from '../../../../richtext';
import { getAssetFromStoryblok, sbEditable, SBProps, StoryblokAsset } from '../../../../utils';

const StoryblokRichtext = dynamic(() =>
  import('../../../../richtext').then(mod => mod.StoryblokRichtext),
);

const ResponsiveImage = dynamic(() =>
  import('@natu/ui/ResponsiveImage').then(mod => mod.ResponsiveImage),
);

interface SBBenefitItemProps {
  title?: string;
  cardImage?: StoryblokAsset;
  cardDescription?: StoryblokRichTextData;
}

export const SBBenefitItem = ({ blok }: SBProps<SBBenefitItemProps>) => {
  const { cardDescription, cardImage } = blok;

  const imageData = getAssetFromStoryblok(cardImage);

  return (
    <div className="h-full" {...sbEditable(blok)}>
      {imageData?.src && (
        <div className="relative h-full overflow-hidden rounded-3xl">
          {cardDescription && (
            <div className="absolute right-4 top-4 w-[66%] rounded-2xl bg-white p-8 xl:w-[460px]">
              <StoryblokRichtext
                className="text-lg leading-7 text-gray-600"
                data={cardDescription}
              />
              <div className="bg-naturaily-butterscotch absolute -bottom-[15px] right-4 h-[30px] w-[30px] rounded-full" />
            </div>
          )}
          <div className="bg-naturaily-airborne absolute bottom-[30px] left-[34px] h-[38px] w-[44px] rounded-bl-full" />
          <ResponsiveImage className="h-full w-full object-cover" {...imageData} />
        </div>
      )}
    </div>
  );
};
